import accounting from 'accounting';

export function toDecimal(value: number) {
  return `${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
}

export function formatAsMoney(amount: number) {
  return accounting.formatMoney(amount, '', 2);
}
